import { Button } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';

// Shown in the widget's dashboard cell while the widget itself is rendered in
// a separate window. Keeps the grid layout stable and offers the way back.
const WidgetPopoutPlaceholder = ({ widgetName, onReturnToWidget, onFocusWindow }) => (
  <div className="d-flex flex-column h-100 w-100 align-items-center justify-content-center gap-3 text-center p-3">
    <FaExternalLinkAlt aria-hidden="true" size={28} style={{ color: 'var(--color-secondary)' }} />
    <p className="m-0" role="status">
      {widgetName ? `${widgetName} is open in a separate window.` : 'Open in a separate window.'}
    </p>
    <div className="d-flex flex-wrap justify-content-center gap-2">
      <Button variant="primary" size="sm" onClick={onReturnToWidget}>
        Return to widget view
      </Button>
      <Button variant="outline-secondary" size="sm" onClick={onFocusWindow}>
        Show window
      </Button>
    </div>
  </div>
);

export default WidgetPopoutPlaceholder;
